<template>
  <v-dialog v-model="dialog" width="380">
    <template #activator="activator">
      <slot name="activator" v-bind="activator"></slot>
    </template>
    <v-card style="background-color: #f9f9f9">
      <v-card-actions
        class="d-flex"
        style="flex-direction: column; background-color: #f9f9f9"
      >
        <v-color-picker
          v-model="colorPickerValue"
          class="mx-auto my-2"
          :swatches="swatches"
          show-swatches
          hide-inputs
          :width="300"
          :canvas-height="80"
          style="background-color: #f9f9f9"
          @update:color="updateColorPickerForCode"
        />
        <v-text-field
          v-model="editColorCode"
          @input="updateColorCodeForColorPicker"
          block
          style="width: 100%"
        />
      </v-card-actions>
      <v-card-actions>
        <v-btn color="error darken-1" text @click="dialog = false">
          キャンセル
        </v-btn>
        <v-spacer />
        <v-btn color="success darken-1" text @click="changeColorCode">
          設定する
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ColorPickerDialog',
  props: {
    defaultColor: {
      type: String,
      default: '#f7f7f7'
    }
  },
  data () {
    return {
      colorPickerValue: '#f7f7f7',
      editColorCode: '#f7f7f7',
      dialog: false,
      swatches: [
        ['#FFFFFF', '#AAAAAA', '#000000'],
        ['#FF0000', '#AA0000', '#550000'],
        ['#FFFF00', '#AAAA00', '#555500'],
        ['#00FF00', '#00AA00', '#005500'],
        ['#00FFFF', '#00AAAA', '#005555'],
        ['#0000FF', '#0000AA', '#000055']
      ]
    }
  },
  watch: {
    defaultColor (value) {
      this.colorPickerValue = value || '#f7f7f7'
      this.editColorCode = value || '#f7f7f7'
    }
  },
  methods: {
    changeColorCode () {
      this.$emit('change-color-code', this.editColorCode)
      this.dialog = false
    },
    updateColorPickerForCode (value) {
      this.editColorCode = value.hex
    },
    updateColorCodeForColorPicker (value) {
      if (!this.isColorHex(value)) return

      this.colorPickerValue = value
    },
    isColorHex (value) {
      return value.match(/^#([0-9a-fA-F]{6})$/) != null
    }
  }
}
</script>
